
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/changelog",
      function () {
        return require("private-next-pages/changelog.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/changelog"])
      });
    }
  